module.exports = __webpack_public_path__ + "img/MercenaryForceCharSelect.ac6370d6.png";